export default "__VITE_ASSET__D9tOR8e$__"